/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['rest/reverseGeocode', 'model/reverseGeocode/reverseGeocode', '../chain', '../validators', '../converters',
    '../utils', 'model/reverseGeocode/batchReverseGeocode'], function(reverseGeocode, model, chain, validators,
    converters, utils, batchModel) {
    'use strict';

    var TYPES = {
        reverseGeocode: 'reverseGeocode',
        crossStreetLookup: 'reverseGeocode/crossStreet'
    };

    function ReverseGeocodeBase(options) {
        this.options = options || {};
        this.options.__serviceType = 'reverseGeocoder';
        this.fields = {};
    }

    ReverseGeocodeBase.prototype.TYPE = TYPES;
    ReverseGeocodeBase.prototype.construct = function() {
        var batchFields;
        this.fields = utils.addFields.call(this, this.fields);
        batchFields = {
            batchItems: {
                validator: validators.arrayOf(this.fields),
                converter: converters.arrayOf(this.fields)
            },
            type: {
                validator: validators.string
            }
        };

        if (Array.isArray(this.options)) {
            return chain.call(this, batchFields, this.handleBatchChain, {
                batchItems: this.options,
                type: this.fields.type.defaultValue
            });
        } else {
            return chain.call(this, this.fields, this.handleChain, this.options);
        }
    };

    ReverseGeocodeBase.prototype.handleBatchChain = function(data, callback) {
        reverseGeocode.batch(this.fields, data, function(response) {
            callback.call(this, batchModel(response));
        });
    };

    ReverseGeocodeBase.prototype.handleChain = function(data, callback) {
        reverseGeocode.reverseGeocode(this.fields, data, function(response) {
            callback.call(this, model(response)[0]);
        });
    };

    function reverseGeocodeConstructor(options) {
        return (new ReverseGeocodeBase(options)).construct();
    }

    reverseGeocodeConstructor.prototype.constructor = ReverseGeocodeBase;

    return reverseGeocodeConstructor;
});



// WEBPACK FOOTER //
// ./services/reverseGeocode/reverseGeocodeBase.js